import {
  Configuration,
  ConfigurationParameters
} from '@/apis/store-core/configuration';
import * as storeCoreApi from '@/apis/store-core/api';
import { storeCoreClientOptions } from 'vue/types/vue';

import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';

export const DEFAULT_STORE_CORE_CLIENT_CONFIG = {
  basePath:
    process.env.VUE_APP_ENV != 'local'
      ? process.env.VUE_APP_STORE_CORE_API_ENDPOINT +
        '/' +
        process.env.VUE_APP_STORE_CORE_API_VERSION +
        '/core'
      : process.env.VUE_APP_STORE_CORE_API_ENDPOINT
};

export default {
  install(Vue: any) {
    Vue.prototype.$storeCoreClient = async (
      options: storeCoreClientOptions = {
        configurationParameters: {
          baseOptions: {
            headers: { 'Cache-Control': 'no-store' },
            adapter: cacheAdapterEnhancer(axios.defaults.adapter!, {
              enabledByDefault: false
            })
          }
        } as ConfigurationParameters
      }
    ) => {
      const config = new Configuration({
        ...DEFAULT_STORE_CORE_CLIENT_CONFIG,
        ...options.configurationParameters
      });
      return {
        backlog: new storeCoreApi.BacklogApi(config),
        email: new storeCoreApi.EmailApi(config)
      };
    };
  }
};
